import IconButton from '@mui/material/IconButton';
import { Add, ArrowDownward, ArrowUpward, KeyboardArrowDown, KeyboardArrowUp, Remove, SortByAlpha } from "@mui/icons-material";
import React, { Component } from "react";
import { Text } from ".";
import * as styleGlobal from "../infra/styleGlobal";
import Button from "./Button";
import { closeModal, openModal } from "./index";
import TitleBar from "./TitleBar";
import View from "./View";


export default class TableMobile extends Component {
  constructor(props) {
    super(props);
    let key = "";
    if (props.sorters) {
      props.sorters.forEach(element => {
        if (element.nome == props.orderInicial && element.key) {
          key = element.key;
        }
      });
    }
    this.cells = [];
    this.state = {
      sorter: props.sorterInicialSorter ? props.sorterInicialSorter : "asc",
      order: key,
      descorder: props.orderInicial
    }
  }

  getActiveSorterOrder() {
    return { sorter: this.state.sorter, order: this.state.order, descorder: this.state.descorder }
  }
  getOrder() {
    let { sorter, descorder } = this.state;
    return (
      <View style={{ flexDirection: "row", flex: 1, }}>
        <Text style={{ alignSelf: 'center', color: styleGlobal.preto }}>{descorder}</Text>
        {sorter == "asc" ? <ArrowUpward style={{ color: styleGlobal.preto, alignSelf: 'center' }} /> : <ArrowDownward style={{ color: styleGlobal.preto, alignSelf: 'center' }} />}
      </View>
    )
  }

  componentDidMount() {
    // this.cells = [];
    if (this.props.onRef) {
      this.props.onRef(this)
      this.props.funcLista(1)
    }
  }
  componentWillUnmount() {
    this.cells = [];

  }

  openAll() {
    this.filtraCells();
    this.cells.forEach(cell => {
      cell.setState({ open: true });

    });

  }

  filtraCells() {
    this.cells = this.cells.filter(function (el) {
      return el != null;
    });

  }
  closeAll() {
    this.filtraCells();
    this.cells.forEach(cell => {
      if (cell != null) {
        cell.setState({ open: false });
      }
    });
  }

  unsubscribe(ref) {
    for (let index = 0; index < this.cells.length; index++) {
      let cell = this.cells[index];
      if (cell == ref) {
        this.cells[index] = null;
      }
    }
  }
  isEven(n) {
    return n % 2 == 0;
  }

  rows() {
    let { tableData = [], sorters, tableHead } = this.props;
    let data = tableData.data ? tableData.data : tableData;
    return data.map((item, index) => {
      let stylerow = { backgroundColor: (this.isEven(index) ? styleGlobal.color7 : 'white') }
      if (tableData.rowStyle) {
        stylerow = { ...stylerow, ...tableData.rowStyle(item) }
      }
      return <TableMobileCell
        subscribe={(ref) => { this.cells.push(ref); }}
        unsubscribe={(ref) => { this.unsubscribe(ref) }}
        stylerow={stylerow}
        index={index} sorters={sorters} head={tableHead} key={index + "" + new Date().getTime()} item={item} />
    })
  }

  openModalsorter = () => {
    openModal(TableModal,
      {
        ...this.props, state: { ...this.state },
        setOrder: (val) => {
          this.setState({ sorter: val.sort, order: val.key, descorder: val.nome }, () => {
            let { sortHandler } = this.props;
            sortHandler(val.nome, val.sort, val.key)
          })
        }
      });
  }
  render() {
    let { tableData, tableHead, sorters, ...others } = this.props;
    return (
      <View>
        <View style={{ ...style.tableHeadKothe, }}>
          {this.getOrder()}
          <IconButton
            style={style.iconbutton}
            size={'small'}
            onClick={this.openModalsorter}
          >
            {<SortByAlpha style={{ color: styleGlobal.preto }} />}
          </IconButton>
          <IconButton
            style={style.iconbutton}
            size={'small'}
            onClick={() => { this.openAll() }}
          >
            {<KeyboardArrowDown style={{ color: styleGlobal.preto }} />}
          </IconButton>
          <IconButton
            style={style.iconbutton}
            size={'small'}
            onClick={() => { this.closeAll() }}
          >
            {<KeyboardArrowUp style={{ color: styleGlobal.preto }} />}
          </IconButton>
        </View>
        {this.rows()}
      </View>
    )
  };
}




class TableMobileCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleCloseOpen = () => {
    this.setState({ open: !this.state.open })
  };

  getHeader() {
    let { sorters } = this.props;
    for (let index = 0; index < sorters.length; index++) {
      let item = sorters[index];
      if (item.headermobile) {
        return index;
      }
    }

    return 0;
  }


  componentDidMount() {
    let { subscribe } = this.props;
    if (subscribe) {
      subscribe(this);
    }
  }

  componentWillUnmount() {
    let { unsubscribe } = this.props;
    if (unsubscribe) {
      unsubscribe(this);
    }
  }

  render() {
    let { item, head, index, sorters, stylerow } = this.props;
    let { open } = this.state;
    return (
      <View key={item._id + "_" + index} style={{ padding: 5, ...stylerow }}>
        <View style={{ flexDirection: 'row' }}>
          <IconButton
            style={{ backgroundColor: styleGlobal.color4, borderRadius: 5, margin: 5, boxShadow: styleGlobal.boxShadow }}
            size={'small'}
            onClick={this.handleCloseOpen}
          >
            {open ? <Remove style={{ color: styleGlobal.color3 }} /> : <Add style={{ color: styleGlobal.color3 }} />}
          </IconButton>
          <Text style={{ alignSelf: 'center', marginLeft: 5, fontWeight: 'bold' }} >{item[this.getHeader()]}</Text>
        </View>
        {open &&
          <View>
            <View style={{ padding: 5, }}>
              {head.map((headitem, index) => {
                if (sorters[index].headermobile) {
                  return null;
                } if (sorters[index].custom) {
                  return item[index]
                } else {
                  return (
                    <View style={style.view1}>
                      <Text style={{ fontWeight: "bold", textAlign: 'left' }} >{headitem + ": "}</Text>
                      <Text style={{ wordWrap: "break-word", textAlign: 'left' }}>{item[index]}</Text>
                    </View>
                  )
                }
              })}
            </View>


          </View>
        }
      </View>
    )
  };
}


class TableModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  setOrder(item, sort) {
    let { setOrder } = this.props;
    setOrder({ ...item, sort })
    closeModal();
  }



  getSelecionadoStyle(selecionado, componente, orderbtn) {
    let { sorter } = this.props.state;

    if (!selecionado) {
      return {}
    }

    if (selecionado) {
      if (sorter == orderbtn) {
        if (componente == "btn") {
          return {
            backgroundColor: styleGlobal.color4
          }
        }
        if (componente == "icon") {
          return {
            color: styleGlobal.color3
          }
        }
      }
    }


    return {};
  }

  render() {
    let { sorters, state } = this.props;
    return (
      <View style={{ maxHeight: "99vh", padding: 10 }}>
        <TitleBar
          titulo={"Ordenação"}
          showBack={false}>
          <View style={{ padding: 5, }}>
            {sorters.map((headitem, index) => {
              if (headitem.key && !headitem.disableSorter) {
                let selecionado = false;
                if (state.order == headitem.key) {
                  selecionado = true;
                }
                return (
                  <View style={style.view2}>
                    <Text style={{ fontWeight: "bold", flex: 1, alignSelf: 'center' }} >{headitem.nome}</Text>
                    <IconButton
                      style={{ ...style.btnarrow, ...this.getSelecionadoStyle(selecionado, "btn", "asc") }}
                      size={'small'}
                      onClick={() => { this.setOrder(headitem, "asc") }}
                    >
                      <ArrowUpward style={{ ...style.arrowicon, ...this.getSelecionadoStyle(selecionado, "icon", "asc") }} />
                    </IconButton>
                    <IconButton
                      style={{ ...style.btnarrow, ...this.getSelecionadoStyle(selecionado, "btn", "desc",) }}
                      size={'small'}
                      onClick={() => { this.setOrder(headitem, "desc") }}
                    >
                      <ArrowDownward style={{ ...style.arrowicon, ...this.getSelecionadoStyle(selecionado, "icon", "desc") }} />
                    </IconButton>
                  </View>
                )
              }
            })}
            <Button
              style={{ width: "auto", marginTop: 30, marginBottom: 10, }}
              text={"Fechar"}
              secondary={true}
              onClick={() => {
                closeModal();
              }} />
          </View>
        </TitleBar>
      </View>
    )
  };
}

const style = {
  view1: { borderBottomStyle: "solid", borderBottomWidth: 0.5, borderColor: styleGlobal.color4, paddingTop: 2.5, paddingBottom: 2.5 },
  view2: { borderBottomStyle: "solid", borderBottomWidth: 0.5, borderColor: styleGlobal.color4, paddingTop: 2.5, paddingBottom: 2.5, flexDirection: 'row' },
  iconbutton: { marginLeft: 2.5, marginRight: 2.5, backgroundColor: styleGlobal.color3, borderRadius: 5, marginTop: 5, marginBottom: 5, boxShadow: styleGlobal.boxShadow, width: 50, alignSelf: 'flex-end' },
  tableHeadKothe: {
    color: "white",
    flexDirection: 'row', backgroundColor: styleGlobal.color8, padding: 2.5, paddingLeft: 10, paddingRight: 10, paddingTop: 5,
    borderTopRightRadius: 15,
    borderTopLeftRadius: 15,
  },
  arrowicon: { color: styleGlobal.preto, alignSelf: 'center' },
}
